const HowToEnroll = () => (
  <div>
    <ol className="list-decimal list-inside text-grays-dark space-y-4">
      <li>
        Visit{' '}
        <a className="underline text-blue-800" href="http://ctionline.com/">
          CTI Online
        </a>
      </li>
      <li>
        Click <strong>Sign In</strong>
      </li>
      <li>
        Click <strong>Access Your Training</strong>
        <div className="my-4 border rounded">
          <img
            className="w-full"
            src="/images/faqs/Access_Training.png"
            alt="Access Your Training"
          />
        </div>
      </li>
      <li>
        Click the <strong>User Menu</strong> in the top left corner and select{' '}
        <strong>Course Catalog</strong>
      </li>
      <li>
        Change the view from <strong>Cards</strong> to <strong>Calendar</strong>
        <div className="my-4 border rounded w-full">
          <img
            className="w-full"
            src="/images/faqs/Cards_To_Calendar.png"
            alt="Change view to Calendar"
          />
        </div>
      </li>
      <li>
        Click on a course to view the details and event dates
        <div className="my-4 border rounded">
          <img
            className="w-full"
            src="/images/faqs/Calendar_View.png"
            alt="Calendar view"
          />
        </div>
      </li>
      <li>
        When selecting a course to enroll, you must select the first event of
        the series from the calendar view. If you select an event that is not
        the first in the series, you will not be prompted to enroll in the
        class.
      </li>
      <li>
        Click <strong>Enroll</strong> to be added to the upcoming session
        <div className="my-4 border rounded">
          <img
            className="w-full"
            src="/images/faqs/Click_Enroll.png"
            alt="Courses to start"
          />
        </div>
        <strong>NOTE</strong>: All Virtual Classroom courses are broken into 2-hour events and
        each course is either 4 or 8 hours in total. You must attend all events
        to earn a passing score.
      </li>
      <li>
        The class will now show up on <strong>My Training Calendar</strong> on
        the homepage.
        <div className="my-4 border rounded">
          <img
            className="w-full"
            src="/images/faqs/My_Training_Calendar.png"
            alt="Courses to start"
          />
        </div>
      </li>
      <li>
        When it’s time to join the class, click on the correct event in the
        Calendar on the homepage, then click <strong>Join</strong>. All classes
        are hosted in Zoom.
      </li>
      <li>
        If you have never logged into Zoom with the email address used to enroll
        in the class, you will need to create a free Zoom account before joining
        the first class event. <strong>Setup a Zoom account here:</strong>{' '}
        <a
          className="underline text-blue-800"
          href="https://zoom.us/signup#/signup"
        >
          Sign Up Free | Zoom
        </a>
      </li>
      <li>
        The class workbook (syllabus) is available to download once enrolled in
        the class
        <div className="my-4 border rounded">
          <img
            className="w-full"
            src="/images/faqs/Workbook_Syllabus.png"
            alt="Courses to start"
          />
        </div>
        Need help with these instructions? Please contact {" "}
        <a className="underline text-blue-800" href="mailto:ctisupport@carquest.com">
          ctisupport@carquest.com
        </a>{' '}
        with the details and we can enroll you in a course when your request is
        submitted at least 24 hours in advance of the start of class.
      </li>
    </ol>
  </div>
)

export default HowToEnroll
